import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import {Router,RouteParams}  from '@angular/router';
import {PhotoService} from './service.photo';
import {Album } from './bean';
//import { ContentService} from './service.content';

@Component({
    selector: 'panel-filter',
    templateUrl: './html/panelFilter.html'
})

export class PanelFilterComponent{
  constructor(
	//private contentService: ContentService,
    public photoService: PhotoService,
	private route: ActivatedRoute,
    private router: Router
    ) {

		if(this.route.snapshot.queryParams['pid'] == null){

			this.photoService.setAlbums();
		}
	}
	ngOnInit(){
		window.addEventListener("orientationchange", () => {
			let timer = setTimeout(() =>{
				this.setFilterVisibility();
			}, 998)
		}, false);
	}

	//prefixCharFilters: Array<String>;
	setFilterVisibility(){
		if(window.innerWidth < 860){
			this.photoService.showFilter = false;
		}
		else{
			this.photoService.showFilter = true;
		}
	}

	showAlbumPhoto(album : Album): void{
		if(album.empty){
			return;
		}
		this.photoService.setCurrentAlbum(album);
		this.setFilterVisibility();
	    document.body.scrollTop = 0;
	    document.documentElement.scrollTop = 0;

	}

    public toggleHideFilter(): void{
        this.photoService.showFilter = ! this.photoService.showFilter;
    }

/*
	changePrefix(prefix: string): void{
		this.bookService.setPrefix(prefix);
	}
	changeSeries(pubClass: PubClass){
////this.bookService.setPubClass(pubClass);
	}
	logout(): void {
		this.authService.logout();
		this.router.navigate(['/login']);
    }
	*/
}



// WEBPACK FOOTER //
// ./src/app/panelFilter.ts